// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridCell_border__zd50E {
  border: 1px dotted #a9a9a9;
}`, "",{"version":3,"sources":["webpack://./src/resolvers/pdf/GridCellForContainer/GridCell.module.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF","sourcesContent":[".border {\n  border: 1px dotted #a9a9a9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"border": `GridCell_border__zd50E`
};
export default ___CSS_LOADER_EXPORT___;
